import React from "react";

export function ArrowIcon(){
  return (
    <path xmlns="http://www.w3.org/2000/svg" d="M7 8L-3.16551e-07 0.712163L0.757932 2.72853e-07L7 6.49874L13.2421 1.36425e-06L14 0.712164L7 8Z" fill="#CC6633"/>
  )
}